import { render } from "./MainProcess.vue?vue&type=template&id=3f99ee22"
import script from "./MainProcess.vue?vue&type=script&lang=js"
export * from "./MainProcess.vue?vue&type=script&lang=js"

import "./MainProcess.vue?vue&type=style&index=0&id=3f99ee22&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__